import React from 'react';
// import _ from 'lodash';
import './InteractiveSliders.css'


/**
 * 
 * default values: n, t, d, k_off
 * inputs: [{key: 'N', rangeLimit: {min: 0, max: 100}, type: 'int'|'float', }]
 */
function ParameterSliders(props) {
    const [parameters, setParameters] = React.useState(
        props.defaultValues
    );

    const [graphParameters, setGraphParameters] = React.useState(
        props.defaultValues
    );

    const handleKeyDown = (event, newParams) => {
        if (event.key === 'Enter') {
        console.log('keydown')
            setGraphParameters(newParams)
        }
      }
console.log(graphParameters)
    const onParameterChange = React.useCallback((key, value) => {
        setParameters({...parameters, [key]: value})
    }, [setParameters, parameters])

  return (
    <div>
    <div className="parameter-sliders">
        {props.inputs.map((parameter) => (
            <div class="filter_line">
                <label>{parameter.key}:</label>
                <input type="number"
                    value={parseFloat(parameters[parameter.key]).toExponential(2)}
                    onInput={(e) => onParameterChange(parameter.key, e.target.value)}
                    onKeyDown={(e) => handleKeyDown(e, {...parameters, [parameter.key]: e.target.value})}
                    />
                <input id="zValue" class="slider" type="range" 
                    min={parameter.rangeLimit.min} 
                    max={parameter.rangeLimit.max} 
                    step={parameter.type === 'int' ? 1 : ((parameter.rangeLimit.max - parameter.rangeLimit.min)/100)} 
                    value={parameters[parameter.key]}
                    onChange={(value) => onParameterChange(parameter.key, value.target.value)}
                    onMouseUp={(value) => setGraphParameters({...parameters, [parameter.key]: value.target.value})}
                    />
            </div>
        ))}
    </div>
    {props.graphComponent && <props.graphComponent {...graphParameters}/>}
    </div>
  );
}

export default ParameterSliders;
